import ApolloClient from 'apollo-boost';
import Cookies from 'js-cookie';
import {
  ACCESS_TOKEN_COOKIE_NAME,
  REFRESH_TOKEN_EXISTS_COOKIE_NAME,
  ensureNonExpiredAccessToken,
} from '@emarketer/auth';
import config from '../../config';

const makeApolloClient = (setIsAuthed) => {
  return new ApolloClient({
    uri: config.graphQLUri,
    request: async (operation) => {
      const currentRefreshTokenExists = !!Cookies.get(REFRESH_TOKEN_EXISTS_COOKIE_NAME); // needed to ensure validation and refresh token if necessary
      const currentAccessToken = Cookies.get(ACCESS_TOKEN_COOKIE_NAME);
      const validAccessToken = await ensureNonExpiredAccessToken(
        config.commonSubscriptionsServiceUrl,
        currentAccessToken,
        currentRefreshTokenExists
      );

      if (!validAccessToken) {
        console.log('No valid auth token available');
        setIsAuthed(false);
      } else {
        setIsAuthed(true);
      }

      operation.setContext({
        headers: {
          authorization: validAccessToken ? `Bearer ${validAccessToken}` : '',
        },
      });
    },
    onError: ({ response, _operation, graphQLErrors, networkError }) => {
      // TODO: log to a persistent log in addition to console.log
      if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) =>
          console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        );

      if (networkError) {
        console.error(`[Network error]: ${networkError}`);
      }

      const errors = response && response.errors ? response.errors : [];
      const authorizationError = errors.find(
        (error) =>
          (error.extensions &&
            error.extensions.exception &&
            error.extensions.exception.name === 'AuthorizationError') ||
          (error.message && error.message === 'No authorization token.')
      );

      if (authorizationError) {
        console.error('authorization error', authorizationError);
        setIsAuthed(false);
      }
    },
  });
};

export default makeApolloClient;
